import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  NgDialogModule,
  TypedFormControl,
  TypedFormGroup,
} from '@principle-theorem/ng-shared';
import { type IPartnerApp } from '@principle-theorem/principle-core/interfaces';

export type EditPartnerAppFormData = Pick<IPartnerApp, 'name'>;

export interface IEditPartnerAppRequest {
  title: string;
  formData?: Partial<EditPartnerAppFormData>;
}

@Component({
  selector: 'pr-edit-partner-app-dialog',
  templateUrl: './edit-partner-app-dialog.component.html',
  styleUrls: ['./edit-partner-app-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgDialogModule],
})
export class EditPartnerAppDialogComponent {
  form = new TypedFormGroup<EditPartnerAppFormData>({
    name: new TypedFormControl(),
  });

  constructor(
    private _dialogRef: MatDialogRef<
      EditPartnerAppDialogComponent,
      EditPartnerAppFormData
    >,
    @Inject(MAT_DIALOG_DATA) public data: IEditPartnerAppRequest
  ) {
    if (data.formData) {
      this.form.patchValue(data.formData);
    }
  }

  submit(): void {
    if (!this.form.valid) {
      return;
    }

    this._dialogRef.close(this.form.getRawValue());
  }
}
